'use strict';

var React = require('react');

var SvgCreditCardSecureMajor = function SvgCreditCardSecureMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1a1.5 1.5 0 0 0-1.5 1.5v1.5h20v-1.5a1.5 1.5 0 0 0-1.5-1.5h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 13.5v-7.5h20v3h-5c-2.757 0-5 2.236-5 4.987v1.013h-8.5a1.5 1.5 0 0 1-1.5-1.5zm2-3.5h5v-2h-5v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 14v1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1v-1a3 3 0 1 0-6 0zm3-1a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1z"
  }));
};

exports.SvgCreditCardSecureMajor = SvgCreditCardSecureMajor;
